import { render, staticRenderFns } from "./backDataAccSummary.vue?vue&type=template&id=db0f2dae&scoped=true&"
import script from "./backDataAccSummary.vue?vue&type=script&lang=js&"
export * from "./backDataAccSummary.vue?vue&type=script&lang=js&"
import style0 from "./backDataAccSummary.vue?vue&type=style&index=0&id=db0f2dae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0f2dae",
  null
  
)

export default component.exports